import Preloader from '../utils/Preloader';
import Localizr from '../utils/Localizr';
import './footer.scss';

class Footer {
  constructor() {
    this.layout();
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('footer-template'), {}));
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('About');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}
}

export default Footer;
